import type { IconSvgObject } from './types';

const ChartHistogramIcon: IconSvgObject = [
  ["path", { d: "M21 21H3V3", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M13 10L13 21M18 13V21M8 13L8 21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M3 7.98693H10C10 6.33729 11.3438 5 12.9934 5C14.6503 5 16 6.34315 16 8L21 7.98693", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default ChartHistogramIcon;
